import $axios from '@/axios-instance.js'

export const logService = {
  getByProjectId,
  getById,
  create,
  update,
  delete: _delete
}

function getByProjectId (id) {
  return $axios.get(`${process.env.ROOT_API}/projectlogs/project/${id}`).then(response => {
    return response.data
  })
}

function getById (id) {
  return $axios.get(`${process.env.ROOT_API}/projectlogs/${id}`).then(response => {
    return response.data
  })
}

function create (log) {
  let user = JSON.parse(localStorage.getItem('user'))
  var projectLog = {
    message: log.message,
    projectId: log.projectId,
    logType: 0,
    userId: user.userId
  }

  return $axios.post(`${process.env.ROOT_API}/projectlogs`, projectLog).then(response => {
    return response.data
  })
}

function update (log) {
  return $axios.put(`${process.env.ROOT_API}/projectlogs/${log.projectLogId}`, log).then(response => {
    return response.data
  })
}

function _delete (id) {
  return $axios.delete(`${process.env.ROOT_API}/projectlogs/${id}`).then(response => {
    return response.data
  })
}



// WEBPACK FOOTER //
// ./src/services/log.service.js